export const features = {
  showBlog: false,
  showEducation: false,
  showExperience: false,
  showSeparator: true,
  showSkills: false,
  showTestimonials: false,
  showWork: true,
};
